let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1TOSZ")).then(() => parcelRequire('6qyXs'));